var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldAltIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4642",
    "data-name": "Group 4642",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 91,
    height: 114,
    viewBox: "0 0 91 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1651",
    "data-name": "Rectangle 1651",
    width: 91,
    height: 114,
    transform: "translate(0 0)",
    fill: "#fdfd96"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4641",
    "data-name": "Group 4641",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14054",
    "data-name": "Path 14054",
    d: "M89.121,9.4a5.706,5.706,0,0,0-4.782-1.156A45.715,45.715,0,0,1,48.852,1.026a5.623,5.623,0,0,0-6.477,0A45.715,45.715,0,0,1,6.888,8.241,5.706,5.706,0,0,0,0,13.851V56.317A51.285,51.285,0,0,0,21.5,98.1l20.815,14.847a5.713,5.713,0,0,0,6.6,0L69.728,98.1a51.285,51.285,0,0,0,21.5-41.782V13.851A5.7,5.7,0,0,0,89.121,9.4m-9.3,46.921A39.874,39.874,0,0,1,63.106,88.809l-17.493,12.5-17.493-12.5A39.874,39.874,0,0,1,11.4,56.317V20.389a56.923,56.923,0,0,0,34.21-7.929,56.923,56.923,0,0,0,34.21,7.929ZM54.4,43.249,39.053,58.666l-5.078-5.139a5.722,5.722,0,1,0-8.081,8.1l9.115,9.123a5.773,5.773,0,0,0,4.044,1.688,5.882,5.882,0,0,0,4.067-1.688L62.718,51.3a5.73,5.73,0,0,0-8.1-8.1Z",
    transform: "translate(0 0)",
    fill: "#fdfd96"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldAltIcon);
export default __webpack_public_path__ + "static/media/shield-alt_icon.3193e75d739ef76c5eb74511a82636f7.svg";
export { ForwardRef as ReactComponent };